import { render } from "./EatingOut.vue?vue&type=template&id=5cf4f2f8"
import script from "./EatingOut.vue?vue&type=script&lang=js"
export * from "./EatingOut.vue?vue&type=script&lang=js"

import exportComponent from "/home/marina-brunello/lifetime/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__